"use strict";
// Using proxy to avoid circular dependencies, occurred after commit
// https://tarkvara.ektaco.ee:3000/EKTACO/CompuAccess/commit/212bd5b45dc44319e10c8e0d43dff5c4296a85fe
// where similar module file was removed from the project.
// @ts-ignore
module.exports = require('./configureStore');
